module.exports = __webpack_public_path__ + "media/images/icon__unlocked@3x-8ec4630f28886340647b8befa612c106.png";